import { useState, FormEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import userIcon from "../../assets/icons/user.svg";
import eyeOpenIcon from "../../assets/icons/eye-open.svg";
import eyeCloseIcon from "../../assets/icons/eye-close.svg";
import axios from "axios";
import { getLoggedUser, logout } from "../../service/helpCaseService";

import logoImg from "../../assets/icons/logo-lisa.svg";
import { PrimaryButton } from "../../components/PrimaryButton";
import {
  Container,
  Content,
  LoginCard,
  Title,
  IconInput,
  Input,
  IconEye,
  ButtonWrapper,
} from "./styles";
import { SecondaryButton } from "../../components/SecondaryButton";
import { Header } from "../../components/Header";
import { Sidebar } from "../../components/SideBar";
import { AccessibilityPopup } from "../../components/AccessibilityPopup";

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [hash, setHash] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorLogin, setErrorLogin] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState(false);
  
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const patch = process.env.REACT_APP_API_URL;
    axios.post(`${patch}/auth/login`, { email, hash })
      .then((response) => {
        const accessToken = response.data.accessToken; 
        const refreshToken = response.data.refreshToken;
        
        localStorage.setItem("token", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        
        navigate("/interprete");
      })
      .catch((error) => {
        setErrorLogin("Usuário ou senha inválidos.");
        console.error("Erro ao fazer login:", error);
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getLoggedUser();
        if (userData) {
          navigate("/interprete");
        }
      } catch (error) {
        logout();
      }
    };

    fetchUserData();
  }, []);

  return (
    <Container>
      <Header
        scenarioName={undefined}
        onBack={() => { }}
        onImportClick={() => { }}
        headerPage={0}
        onEvalClick={() => { }}
        toggleSidebar={() => setShowSidebar(!showSidebar)}
        showSidebar={showSidebar}
        isAccessibilityOpen={isAccessibilityOpen}
        setIsAccessibilityOpen={setIsAccessibilityOpen}
        backToHome={()=>navigate("/home")}
        Aimode={false}
        closeAimode={()=>{}}
      />
      <Sidebar
        open={showSidebar}
        onClose={() => setShowSidebar(false)}
      />
      <AccessibilityPopup isOpen={isAccessibilityOpen} onClose={() => setIsAccessibilityOpen(false)} />

      <Content>
        

        <LoginCard>
          <img src={logoImg} alt="Logo" />
          <Title>Painel do intérprete</Title>
          
          <form onSubmit={handleSubmit}>
            <IconInput>
              <Input
                type="text"
                placeholder="Usuário"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <img src={userIcon} className="user-icon" alt="Usuário" />
            </IconInput>

            <IconInput>
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Senha"
                value={hash}
                onChange={(e) => setHash(e.target.value)}
                required
              />
              <IconEye  
                type="button"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              >
                {showPassword ? <img className="eye-icon" src={eyeOpenIcon} alt="Esconder senha" /> : <img className="eye-icon" src={eyeCloseIcon} alt="Mostrar senha" />}
              </IconEye>
            </IconInput>

            {errorLogin && <p className="error-login">Usuário ou senha inválidos. Tente novamente.</p>}

            <ButtonWrapper>
              <PrimaryButton type="submit"> <span>ENTRAR</span></PrimaryButton>
            </ButtonWrapper>
              <SecondaryButton onClick={() => navigate("/home")} type="button"> <span>Voltar para a home</span></SecondaryButton>
          </form>
        </LoginCard>
      </Content>
    </Container>
  );
}
